import moment from 'moment';
import React, { Component } from 'react';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';



class EditDeliveries extends Component {
    sid = Context.GetContext().Sid;
    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;

        if (!Context.IsLogged()) {
            return;
        }
        var d1 = moment();
        var d2 = moment();




        this.state = {
            StartDate: d1,
            EndDate: d2,
            Rows: this.Search(d1, d2)
        };

        this.Search = this.Search.bind(this);
        this.Delete = this.Delete.bind(this);
        this.ChangeDate = this.ChangeDate.bind(this);
    }

    Search(d1, d2) {
        var data = {
            session: this.sid,
            from: d1.format("YYYYMMDD"),
            to: d2.format("YYYYMMDD")
        };
        return Comm.AllDeliveries(data);

    }

    Delete(id) {
        if (!window.confirm(Translation.Trans("pleaseconfirm")))
            return;
        var data = {
            session: this.sid,
            id: id
        };
        Comm.DeleteDelivery(data);
        this.setState({
            Rows: this.Search(this.state.StartDate, this.state.EndDate)
        });


    }

    ChangeDate(d1, d2) {

        d1 = d1 || this.state.StartDate;
        d2 = d2 || this.state.EndDate;


        this.setState({
            StartDate: d1,
            EndDate: d2,
            Rows: this.Search(d1, d2)
        });
    }




    render() {

        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }
        if (Context.RenderNotOK(this.props.history))
            return null;




        return (
            Context.HasRight("reditdeliveries") ?

                <div className="panel panel-default">
                    <div className="panel-heading">{Translation.Trans("editdeliveries")}</div>
                    <div className="panel-body">


                        <div className="col-md-12">
                            <div className="col-md-6">
                                <label for="dpStartDateAnd">{Translation.Trans("FromDate")}</label>
                                <Datetime
                                    inputProps={{ placeholder: 'N/A', readOnly: "true", className: "form-control pointhand" }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat=""
                                    onChange={(e) => { this.ChangeDate(e, null); }}
                                    value={this.state.StartDate}
                                    closeOnSelect="true"
                                ></Datetime>

                            </div>
                            <div className="col-md-6">
                                <label for="dpEndDateAnd">{Translation.Trans("ToDate")}</label>
                                <Datetime
                                    inputProps={{ placeholder: 'N/A', readOnly: "true", className: "form-control pointhand" }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat=""
                                    onChange={(e) => { this.ChangeDate(null, e); }}
                                    value={this.state.EndDate}
                                    closeOnSelect="true"
                                ></Datetime>

                            </div>
                        </div>

                        <div className="col-md-12">
                            <br /><br />
                            <table className="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>{Translation.Trans("contragent")}</th>
                                        <th>{Translation.Trans("invoice")}</th>
                                        <th>{Translation.Trans("invoicedate")}</th>
                                        <th>{Translation.Trans("onroad")}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.Rows.deliveries ?
                                        this.state.Rows.deliveries.map(item =>
                                            <tr>
                                                <td>{item.partner_name}</td>
                                                <td>{item.invoice_nom}</td>
                                                <td>{moment(Date(item.invoice_date)).format("DD.MM.YYYY")}</td>
                                                <td>{item.on_the_road ? <i class="far fa-check-square"></i> : null}</td>
                                                <td><a onClick={() => this.Delete(item.id)}><i class="far fa-trash-alt"></i></a></td>
                                            </tr>

                                        )
                                        :
                                        null}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div >
                :
                <div>{Translation.Trans("noRights")}</div>
        );
    }

}


export default EditDeliveries;


// WEBPACK FOOTER //
// ./src/pages/editdeliveries.js